import { FC } from 'react';
import { Center, Stack, Text } from '@chakra-ui/react';

type Props = {
  title: string;
  subtitle: string;
};

export const EmptyState: FC<Props> = ({ title, subtitle }) => (
  <Center flex={1} data-testid="empty-state">
    <Stack width="80" textAlign="center">
      <Text fontSize="lg" fontWeight="bold">
        {title}
      </Text>
      <Text fontSize="sm" fontWeight="bold" color="gray.500">
        {subtitle}
      </Text>
    </Stack>
  </Center>
);
